import { AccreditationEligibilityCriteriaEnumType } from '__generated__/graphql';

export default function accreditationCriteriaToReadable(
  role: AccreditationEligibilityCriteriaEnumType
): {
  label: string;
  color: string;
} {
  switch (role) {
    case AccreditationEligibilityCriteriaEnumType.AnnualIncome:
      return {
        label: 'Annual Income',
        color: 'gray',
      };
    case AccreditationEligibilityCriteriaEnumType.NetWorth:
      return {
        label: 'Net Worth',
        color: 'purple',
      };
    case AccreditationEligibilityCriteriaEnumType.Combined:
      return {
        label: 'Combined',
        color: 'green',
      };
    case AccreditationEligibilityCriteriaEnumType.JointApplicant:
      return {
        label: 'Joint Application',
        color: 'blue',
      };
    default:
      return {
        label: role,
        color: 'gray',
      };
  }
}
